import get from 'lodash/get';

export interface DynamicComponentProps {
  _componentTypes: Record<string, any>;
  _defaultComponent?: any;
  _field?: string;
  [key: string]: any;
}

const DynamicComponent = ({
  _componentTypes,
  _defaultComponent = () => null,
  _field = '_meta.schema',
  ...props
}: DynamicComponentProps) => {
  const schema = get(props, _field);
  const ComponentKey = schema
    ? Object.keys(_componentTypes).find(key => schema.endsWith(key))
    : undefined;

  const Component =
    (ComponentKey && _componentTypes[ComponentKey]) ||
    _componentTypes['default'] ||
    _defaultComponent;

  const deliveryId = props?._meta?.deliveryId;
  const isProd = process.env.NEXT_PUBLIC_APP_ENV === 'production';

  const wrapped = <Component {...props} />;

  return isProd ? (
    wrapped
  ) : (
    <span
      data-delivery-id={deliveryId || undefined}
      data-schema={schema || undefined}
      style={{ display: 'contents' }}
    >
      {wrapped}
    </span>
  );
};

export default DynamicComponent;
